let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3KhJx")).then(() => parcelRequire('1tjmg'));